// redux/features/bcrSlice.ts
import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
} from '@reduxjs/toolkit';
import api from '@/axiosSetup';
import { IBCR } from '../../../types/IBCR';

export type RelationType = 'Reference' | 'Replace';

interface BCRState {
  bcrs: IBCR[];
  loading: boolean;
  error: string | null;

  draftCount: number;
  draftCountLoading: boolean;
  draftCountError: string | null;
}

const initialState: BCRState = {
  bcrs: [],
  loading: false,
  error: null,

  draftCount: 0,
  draftCountLoading: false,
  draftCountError: null,
};

export const fetchAllBCRs = createAsyncThunk<
  IBCR[],
  { includeArchived?: boolean } | undefined,
  { rejectValue: string }
>("bcr/fetchAll", async (args, { rejectWithValue }) => {
  try {
    const includeArchived = args?.includeArchived ?? false;

    const res = await api.get("/api/bcrs", {
      params: { includeArchived },
    });

    return res.data;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to fetch BCRs"
    );
  }
});

export const fetchDraftBCRCount = createAsyncThunk<
  number,
  { includeArchived?: boolean } | undefined,
  { rejectValue: string }
>("bcr/fetchDraftCount", async (args, { rejectWithValue }) => {
  try {
    const includeArchived = args?.includeArchived ?? false;

    const res = await api.get("/api/bcrs/draft-count", {
      params: { includeArchived },
    });

    return res.data.count;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to fetch draft BCR count"
    );
  }
});

const bcrSlice = createSlice({
  name: 'bcr',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch all BCRs
      .addCase(fetchAllBCRs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBCRs.fulfilled, (state, action: PayloadAction<IBCR[]>) => {
        state.loading = false;
        state.bcrs = action.payload;
      })
      .addCase(fetchAllBCRs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Failed to fetch BCRs';
      })

      // Fetch draft BCR count
      .addCase(fetchDraftBCRCount.pending, (state) => {
        state.draftCountLoading = true;
        state.draftCountError = null;
      })
      .addCase(fetchDraftBCRCount.fulfilled, (state, action: PayloadAction<number>) => {
        state.draftCountLoading = false;
        state.draftCount = action.payload;
      })
      .addCase(fetchDraftBCRCount.rejected, (state, action) => {
        state.draftCountLoading = false;
        state.draftCountError =
          action.payload ?? 'Failed to fetch draft BCR count';
      });
  },
});

export default bcrSlice.reducer;

// // redux/features/bcrSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction, createSelector } from '@reduxjs/toolkit';
// import api from '@/axiosSetup';
// import { IBCR } from '../../../types/IBCR';

// export type RelationType = 'Reference' | 'Replace';

// interface BCRState {
//   bcrs: IBCR[];
//   loading: boolean;
//   error: string | null;
// //   current: IBCR | null;
// }

// const initialState: BCRState = {
//   bcrs: [],
//   loading: false,
//   error: null
// };

// const bcrSlice = createSlice({
//   name: 'bcr',
//   initialState,
//   reducers: {
//     // clearCurrent(state) {
//     //   state.current = null;
//     //   state.currentError = null;
//     //   state.currentLoading = false;
//     // },
//   },
//   extraReducers: (builder) => {
//     // Fetch all
//     builder
//       .addCase(fetchAllBCRs.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAllBCRs.fulfilled, (state, action: PayloadAction<IBCR[]>) => {
//         state.loading = false;
//         state.bcrs = action.payload;
//       })
//       .addCase(fetchAllBCRs.rejected, (state, action) => {
//         state.loading = false;
//         state.error = (action.payload as string) ?? 'Failed to fetch BCRs';
//       });
//   },
// });

// export const fetchAllBCRs = createAsyncThunk<
//   IBCR[],
//   { includeArchived?: boolean } | undefined,
//   { rejectValue: string }
// >("bcr/fetchAll", async (args, { rejectWithValue }) => {
//   try {
//     const includeArchived = args?.includeArchived ?? false;
//     const res = await api.get("/api/bcrs", { params: { includeArchived } });
//     return res.data;
//   } catch (err: any) {
//     return rejectWithValue(err.response?.data?.message || "Failed to fetch BCRs");
//   }
// });

// export const {  } = bcrSlice.actions;
// // export const { clearCurrent } = bcrSlice.actions;
// export default bcrSlice.reducer;